import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import tours from "../../../datebase/tours";
import axios from "axios";
import "./request.css"
import { Link, useParams } from "react-router-dom";
const Request = ({ t, langcat, Swiper, SwiperSlide, Navigation, Pagination, Mousewheel, Autoplay, setScoreTours, scoreTours }) => {
    const { id } = useParams();
    const formRequred = (e) => {
        const name = document.querySelector("#name");
        const nameActive = document.querySelectorAll(".nameActive");
        const kolvo = document.querySelector("#kolvo");
        const kolvoActive = document.querySelectorAll(".kolvoActive");
        const date = document.querySelector("#date");
        const dateActive = document.querySelectorAll(".dateActive");
        const email = document.querySelector("#email");
        const emailActive = document.querySelectorAll(".emailActive");
        const requestinfomessage = document.querySelector(".request-info-message");
        let hasError = false;
        if (name.value.trim() === "") {
            nameActive.forEach(el => {
                el.classList.add("active");
            });
            hasError = true;
        }
        else {
            nameActive.forEach(el => {
                el.classList.remove("active");
            });
        }

        if (kolvo.value === "0") {
            kolvoActive.forEach(el => {
                el.classList.add("active");
            });
            hasError = true;
        }
        else {
            kolvoActive.forEach(el => {
                el.classList.remove("active");
            });
        }

        if (date.value === "") {
            dateActive.forEach(el => {
                el.classList.add("active");
            });
            hasError = true;
        }
        else {
            dateActive.forEach(el => {
                el.classList.remove("active");
            });
        }

        if (email.value.trim() === "") {
            emailActive.forEach(el => {
                el.classList.add("active");
            });
            hasError = true;
        }
        else {
            emailActive.forEach(el => {
                el.classList.remove("active");
            });
        }

        if (hasError) {
            requestinfomessage.classList.add("active");
        } else {
            requestinfomessage.classList.remove("active");
            form1func();
            showStatus(true)
        }
    }
    const form1func = (e) => {
        const TOKEN = "6987592551:AAFnBgdjEOXi7m9Ja857NMX-4iWe5YQq41k";
        const CHAT_ID = "-1003658109531";
        const URI_API = `https://api.telegram.org/bot${TOKEN}/sendMessage`;
        const name = document.querySelector("#name");
        const kolvo = document.querySelector("#kolvo");
        const kolvonum = document.querySelector("#kolvonum");
        const date = document.querySelector("#date");
        const phoneNumber = document.querySelector("#phoneNumber");
        const email = document.querySelector("#email");
        const message = document.querySelector("#message");
        const tour = tours.find(koks => koks.id == id);
        const persons =
            kolvo.value == "5"
                ? Number(kolvonum.value) || 0
                : Number(kolvo.value) || 0;
        const priceObj = tour.prices.find(e => Number(e.persons) === persons);
        const price = priceObj ? Number(priceObj.price) : 0;
        const extraItems = (tour.inclusionBuy || []).filter((item) =>
            selectedExtras.includes(item.id)
        );

        const extrasPrice = extraItems.reduce((sum, item) => sum + Number(item.price), 0);
        const finalPrice = price + extrasPrice;
        let mes = `<b>❇️ ❇️ Новая заявка c сайта ❇️ ❇️</b>\n\n`;
        mes += `<b>🏞Туры: </b>${tour ? tour.name + " " + tour.dayDuration : ""}\n`;
        mes += `<b>🆔ФИО: </b>${name.value}\n`;
        mes += `<b>📅Дата поездки: </b>${date.value}\n`;
        mes += `<b>👨‍👩‍👦Количество путешественников: </b>${kolvo.value == "5" ? kolvonum.value : kolvo.value}\n`;
        mes += `<b>➕Доп. услуги: </b>${extraItems.length
            ? extraItems.map((item) => `${item.name} ($${item.price})`).join(", ")
            : "Нет"
            }\n`;
        mes += `<b>🤑Цена: </b>$${finalPrice}\n`;
        mes += `<b>📲Номер Телефон: </b>${phoneNumber.value} \n`;
        mes += `<b>💌Почта: </b>${email.value} \n\n`;
        mes += `<b>💬Сообщение: </b>${message.value} \n`;
        axios.post(URI_API, {
            chat_id: CHAT_ID,
            parse_mode: "HTML",
            text: mes
        })
            .then((res) => {
            })
            .catch((error) => {
            })
            .finally(() => {
                name.value = "";
                kolvo.value = "0";
                kolvonum.value = "";
                date.value = "";
                phoneNumber.value = "";
                email.value = "";
                message.value = ""
            })
    }
    const [selectedDate, setSelectedDate] = useState('');
    const formatDate = (dateString) => {
        if (!dateString) return langcat === 'rus' ? 'Выберите дату' : 'Choose data';
        const date = new Date(dateString);
        const locale = langcat === 'rus' ? 'ru-RU' : 'en-GB';
        return date.toLocaleDateString(locale, {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    const getNextDay = (dateString) => {
        let unitNight = 0;

        const tour = tours.find((koks) => koks.id == id);
        if (tour) {
            unitNight = Number(tour.unitNight);
        }

        if (!dateString) return langcat === 'rus' ? 'Выберите дату' : 'Choose data';

        const date = new Date(dateString);
        date.setDate(date.getDate() + unitNight);
        return formatDate(date);
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };
    useEffect(() => {
        let sum = 0;
        for (let index = 0; index < tours.at(id - 1).feedback.length; index++) {
            const element = tours.at(id - 1).feedback[index].score;
            sum += element;
            let sredniy = sum / tours.at(id - 1).feedback.length;
            setScoreTours(sredniy.toFixed(1));
        }
    });
    const [kolvonumstats, setkolvonumstats] = useState('');

    const kolvonum = () => {
        const kolvo = document.querySelector("#kolvo");
        const kolvonuminp = document.querySelector("#kolvonum");
        if (kolvo.value == "0") {
            kolvonuminp.classList.remove("active")
            setkolvonumstats("")
        }
        else if (kolvo.value == "1") {
            setkolvonumstats("1person")
            kolvonuminp.classList.remove("active")
        }
        else if (kolvo.value == "2") {
            setkolvonumstats("2person")
            kolvonuminp.classList.remove("active")
        }
        else if (kolvo.value == "3") {
            setkolvonumstats("3person")
            kolvonuminp.classList.remove("active")
        }
        else if (kolvo.value == "4") {
            setkolvonumstats("4person")
            kolvonuminp.classList.remove("active")
        }
        else if (kolvo.value == "5") {
            setkolvonumstats("5person")
            kolvonuminp.classList.add("active")
        }
    }
    const renderUsers = () => {
        if (kolvonumstats === "1person") {
            return <i className="fa fa-user" aria-hidden="true"></i>;
        }
        else if (kolvonumstats === "2person") {
            return (
                <>
                    <i className="fa fa-user" />
                    <i className="fa fa-user" />
                </>
            );
        }
        else if (kolvonumstats === "3person") {
            return (
                <>
                    <i className="fa fa-user" />
                    <i className="fa fa-user" />
                    <i className="fa fa-user" />
                </>
            );
        }
        else if (kolvonumstats === "4person") {
            return (
                <>
                    <i className="fa fa-user" />
                    <i className="fa fa-user" />
                    <i className="fa fa-user" />
                    <i className="fa fa-user" />
                </>
            );
        }
        else if (kolvonumstats === "5person") {
            return (
                <>
                    <i class="fa fa-users" aria-hidden="true"></i>
                    <i class="fa fa-users" aria-hidden="true"></i>
                    <i class="fa fa-users" aria-hidden="true"></i>
                </>
            );
        }
        return null;
    };
    const [selectedExtras, setSelectedExtras] = useState([]);

    const currentTour = tours.find((tour) => tour.id == id);

    const personsCount =
        kolvonumstats === "5person"
            ? Number(document.querySelector("#kolvonum")?.value || 0)
            : Number(kolvonumstats?.[0]) || 0;

    const basePriceObj = currentTour?.prices.find(
        (e) => Number(e.persons) === personsCount
    );

    const basePrice = basePriceObj ? Number(basePriceObj.price) : 0;

    const extrasTotal = (currentTour?.inclusionBuy || []).reduce((sum, item) => {
        return selectedExtras.includes(item.id) ? sum + Number(item.price) : sum;
    }, 0);

    const finalTotal = basePrice + extrasTotal;

    const perPersonPrice =
        personsCount > 0 ? (finalTotal / personsCount).toFixed(1) : "0.0";

    const toggleExtra = (id) => {
        setSelectedExtras((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };
    const [textActive, setTextActive] = useState(false);
    function TypingText({ text, speed = 30, active }) {
        const [output, setOutput] = useState("");
        const [index, setIndex] = useState(0);

        useEffect(() => {
            if (!active) {
                setOutput("");
                setIndex(0);
                return;
            }

            if (index < text.length) {
                const timer = setTimeout(() => {
                    setOutput(prev => prev + text[index]);
                    setIndex(prev => prev + 1);
                }, speed);

                return () => clearTimeout(timer);
            }
        }, [index, text, speed, active]);

        return <span className="typing-text">{output}</span>;
    }
    function showStatus(e) {
        const requeststatusscreen = document.querySelector(".request-status-screen")
        const spinnerblock = document.querySelector(".spinner-block")
        const checkblock = document.querySelector(".check-block")
        if (e == true) {
            requeststatusscreen.classList.add("active");
            spinnerblock.classList.add("activeSpiner");
            checkblock.classList.remove("active");
            spinnerblock.classList.remove("activeCheck");
            setTextActive(false)

            setTimeout(() => {
                spinnerblock.classList.remove("activeSpiner");
                checkblock.classList.add("active");
                spinnerblock.classList.add("activeCheck");
                setTextActive(true)

            }, 3000);
        }
        else {
            requeststatusscreen.classList.remove("active");
            spinnerblock.classList.remove("activeSpiner");
            checkblock.classList.remove("active");
            spinnerblock.classList.remove("activeCheck");
            setTextActive(false)
        }
    }
    return (
        <>
            {
                tours.map((koks) => {

                    if (koks.id == id) {
                        document.title = koks.name
                        return (
                            <>
                                <div className="request">
                                    <div className="request-status-screen">
                                        <div className="request-status-screen-flex">
                                            <div className="spinner-block">
                                                <span>
                                                    <i class="fa fa-spinner" aria-hidden="true"></i>
                                                </span>
                                                <span>
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <div className="check-block">
                                                <span id="typingText">
                                                    <TypingText active={textActive} text={t("requeststatusscreen")} speed={20} />
                                                </span>
                                                <span>
                                                    <button onClick={() => { showStatus(false) }}>
                                                        {t("close")}
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container">
                                        <div className="request-flex">
                                            {/* <div className="request-box1">
                                                <h1>{t("servicebox3-3")}</h1>
                                            </div> */}
                                            <div className="request-box2">
                                                <div className="request-box2-sec1">
                                                    <div className="request-box2-sec1-block1">
                                                        <div className="request-box2-sec1-block1-flex">
                                                            <div className="request-box2-sec1-block1-img">
                                                                <img src={`/${koks.img[0]}.jpg`} alt="" />
                                                            </div>
                                                            <div className="request-box2-sec1-block1-info">
                                                                <h5>
                                                                    {koks.name}
                                                                </h5>
                                                                <div className="tourDetails-sec1-box2-tourname-name-stars">
                                                                    {Array.from({ length: 5 }, (_, i) => {
                                                                        const rating = Number(scoreTours);
                                                                        const starValue = i + 1;

                                                                        if (rating >= starValue) {
                                                                            return <i key={i} className="fa fa-star active-star" />;
                                                                        }
                                                                        else if (rating >= starValue - 0.5) {
                                                                            return <i key={i} className="fa fa-star-half-o active-star" />;
                                                                        }
                                                                        else {
                                                                            return <i key={i} className="fa fa-star-o" />;
                                                                        }
                                                                    })}
                                                                    <h3>{scoreTours}</h3>
                                                                </div>
                                                                <span>
                                                                    <h6>
                                                                        {koks.dayDuration}
                                                                    </h6>
                                                                    <Link
                                                                        onClick={() => window.scrollTo(0, 0)}
                                                                        className="link"
                                                                        to={`/tours/${koks.id}`}
                                                                    >
                                                                        {t("viewfullitinerary")}
                                                                    </Link>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="request-box2-sec1-block2">
                                                        <div className="request-box2-sec1-block2-flex">
                                                            <div className="request-box2-sec1-block2-input">
                                                                <label className="lab nameActive" for="name">{t("request.fio")}</label>
                                                                <input className="inp nameActive" id="name" type="text" />
                                                            </div>
                                                            <div className="request-box2-sec1-block2-input">
                                                                <label className="lab kolvoActive" for="kolvo">{t("request.kolvoPut")}</label>
                                                                <select className="inp kolvoActive" name="kolvo" id="kolvo" onChange={kolvonum}>
                                                                    <option value="0">{t("choose")}</option>
                                                                    <option value="1">{t("1person")}</option>
                                                                    <option value="2">{t("2person")}</option>
                                                                    <option value="3">{t("3person")}</option>
                                                                    <option value="4">{t("4person")}</option>
                                                                    <option value="5">{t("5person")}</option>
                                                                </select>
                                                                <input id="kolvonum" type="number" placeholder={`(${t("request.kolvoPut")})`} />
                                                            </div>
                                                            {currentTour?.inclusionBuy?.length > 0 && (
                                                                <div className="request-box2-sec1-block2-input">
                                                                    <label>{t("additional")}</label>
                                                                    <div className="request-extra-services">
                                                                        {currentTour.inclusionBuy.map((item) => {
                                                                            const checkboxId = `extra-${item.id}`;

                                                                            return (
                                                                                <span
                                                                                    key={item.id}
                                                                                    className="request-extra-services-span"
                                                                                >
                                                                                    <input
                                                                                        id={checkboxId}
                                                                                        type="checkbox"
                                                                                        checked={selectedExtras.includes(item.id)}
                                                                                        onChange={() => toggleExtra(item.id)}
                                                                                    />

                                                                                    <label htmlFor={checkboxId}>
                                                                                        {item.name} - US ${item.price}
                                                                                    </label>
                                                                                </span>
                                                                            );
                                                                        })}
                                                                    </div>

                                                                </div>
                                                            )}
                                                            <div className="request-box2-sec1-block2-input">
                                                                <label className="lab dateActive" htmlFor="date">{t("request.date")}</label>
                                                                <input
                                                                    className="inp dateActive"
                                                                    type="date"
                                                                    id="date"
                                                                    value={selectedDate}
                                                                    onChange={handleDateChange}
                                                                />
                                                            </div>
                                                            <div className="request-box2-sec1-block2-input">
                                                                <label for="phoneNumber">{t("request.phonenumber")}</label>
                                                                <input id="phoneNumber" type="number" />
                                                            </div>
                                                            <div className="request-box2-sec1-block2-input">
                                                                <label className="lab emailActive" for="email">{t("request.email")}</label>
                                                                <input className="inp emailActive" id="email" type="email" />
                                                            </div>
                                                            <div className="request-box2-sec1-block2-input">
                                                                <label for="message">{t("request.soobchenie")}</label>
                                                                <textarea name="message" placeholder={`(${t("request.soobcheniedp")})`} className="message" id="message" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="request-box2-sec2">
                                                    <div className="request-box2-sec2-block1">
                                                        <div className="request-box2-sec2-block1-flex">
                                                            <div className="request-box2-sec2-block1-info1">
                                                                <h5>
                                                                    {t("totalamount")}
                                                                </h5>
                                                            </div>
                                                            <div className="request-box2-sec2-block1-info2">
                                                                <div>
                                                                    <span><i className="fa fa-calendar" aria-hidden="true"></i></span>
                                                                    <span>
                                                                        <h6>{t("tripstart")}</h6>
                                                                        <h5>{formatDate(selectedDate)}</h5>
                                                                        <h4>{koks.startCountry}</h4>
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <span><i className="fa fa-calendar" aria-hidden="true"></i></span>
                                                                    <span>
                                                                        <h6>{t("tripend")}</h6>
                                                                        <h5>{getNextDay(selectedDate)}</h5>
                                                                        <h4>{koks.endCountry}</h4>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="request-box2-sec2-block1-info3">
                                                                <div>
                                                                    <h4>{t("trip")}</h4>
                                                                    <span>
                                                                        {renderUsers()}
                                                                        <h5>
                                                                            {t(kolvonumstats)}
                                                                        </h5>
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <h4>
                                                                        {t("summary")}
                                                                    </h4>
                                                                    <h5>
                                                                        {personsCount > 0
                                                                            ? `${personsCount} x $${perPersonPrice}`
                                                                            : "$0"}
                                                                    </h5>
                                                                    {/* <h5>
                                                                        {
                                                                            (() => {
                                                                                const priceObj = koks.prices.find(e => Number(kolvonumstats[0]) == e.persons);
                                                                                return priceObj
                                                                                    ? `${Number(kolvonumstats[0])} x US $${(priceObj.price / Number(kolvonumstats[0])).toFixed(1)} `
                                                                                    : "$0";
                                                                            })()
                                                                        }
                                                                        {
                                                                            koks.prices.map((e) => {
                                                                                if (Number(kolvonumstats[0]) == e.persons) {
                                                                                    return (
                                                                                        <>
                                                                                            {Number(kolvonumstats[0])} x US ${(e.price / Number(kolvonumstats[0])).toFixed(1)}
                                                                                        </>
                                                                                    )
                                                                                }
                                                                            })
                                                                        }
                                                                    </h5> */}
                                                                </div>
                                                            </div>
                                                            {
                                                                Number(kolvonumstats[0]) == 5 && (
                                                                    <div className="request-box2-sec2-block1-info6">
                                                                        <h5>{t("requestinfo6text")}</h5>
                                                                    </div>
                                                                )
                                                            }

                                                            <div className="request-box2-sec2-block1-info4">
                                                                <span>
                                                                    <h4>{t("total")}</h4>
                                                                </span>
                                                                <span>
                                                                    <h5>US ${finalTotal}</h5>
                                                                    {/* <h5>US $
                                                                        {
                                                                            (() => {
                                                                                const priceObj = koks.prices.find(e => Number(kolvonumstats[0]) == e.persons);
                                                                                return priceObj ? priceObj.price : "0";
                                                                            })()
                                                                        }
                                                                    </h5> */}
                                                                </span>
                                                            </div>
                                                            <div className="request-box2-sec2-block1-info5">
                                                                <h5>
                                                                    *{t("requestinfo5text")}
                                                                </h5>
                                                            </div>
                                                            <div className="request-info-message">
                                                                {t("requestinfomessage")}
                                                            </div>
                                                            <div className="request-box2-sec2-block1-btn6">
                                                                <div>
                                                                    <button onClick={formRequred}>{t("btn-zayav")}</button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="request-box2-sec2-block2">
                                                        <div className="request-box2-sec2-block2-flex">
                                                            <div className="request-box2-sec2-block2-info1">
                                                                <h4>{t("requestblock2info1text1")}</h4>
                                                                <h5>{t("requestblock2info1text2")}</h5>
                                                            </div>
                                                            <div className="request-box2-sec2-block2-info2">
                                                                <h4>{t("requestblock2info2text1")}</h4>
                                                                <span>
                                                                    <h5>{t("requestblock2info2text2")}</h5>
                                                                </span>
                                                                <span>
                                                                    <img src="/solution.png" alt="" />
                                                                </span>
                                                                <span>
                                                                    <a href="" className="link">{t("experiencesSwiper-box-text4")}</a>
                                                                </span>
                                                               
                                                                {/* <span>
                                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                                    <h5>{t("requestblock2info2text9")}</h5>
                                                                </span> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                })
            }
        </>
    )
}
export default Request